import { screenMdMin, screenSmMin } from '@spotify-internal/encore-foundation';
import { Type } from "../../../core/components/Type/index.mjs";
import styled from "../../../core/styled-components.mjs";
import { cssColorVar, cssSpacing } from "../../../core/styles/index.mjs";
var variantColors = {
  informational: 'textSubdued',
  announcement: 'textBrightAccent',
  success: 'textPositive',
  warning: 'textWarning',
  failure: 'textNegative'
};
var propsToColorVar = function propsToColorVar(_ref) {
  var _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'informational' : _ref$variant;
  return "var(".concat(cssColorVar(variantColors[variant]), ")");
};
export var Heading = styled(Type.h1).attrs({
  variant: 'forte'
}).withConfig({
  displayName: "indexstyled__Heading",
  componentId: "sc-1n3g30k-0"
})([""]);
export var Superheading = styled(Type.h2).attrs({
  variant: 'altoBrio'
}).withConfig({
  displayName: "indexstyled__Superheading",
  componentId: "sc-1n3g30k-1"
})(["margin-bottom:", ";"], cssSpacing('base', '16px'));
export var Subheading = styled(Type.h2).attrs({
  variant: 'altoBrio'
}).withConfig({
  displayName: "indexstyled__Subheading",
  componentId: "sc-1n3g30k-2"
})(["margin-top:", ";color:var(", ");@media (min-width:", "){line-height:54px;font-size:46px;}@media (min-width:", "){line-height:64px;font-size:56px;}"], cssSpacing('looser', '24px'), cssColorVar('textBase'), screenSmMin, screenMdMin);
export var Details = styled(Type.p).attrs({
  variant: 'ballad'
}).withConfig({
  displayName: "indexstyled__Details",
  componentId: "sc-1n3g30k-3"
})(["margin-top:", ";"], cssSpacing('looser', '24px'));
export var Wrapper = styled.header.withConfig({
  displayName: "indexstyled__Wrapper",
  componentId: "sc-1n3g30k-4"
})(["", "{color:", ";}"], Superheading, propsToColorVar);
export var WrapperMain = styled.div.withConfig({
  displayName: "indexstyled__WrapperMain",
  componentId: "sc-1n3g30k-5"
})(["margin-bottom:", ";"], function (_ref2) {
  var condensed = _ref2.condensed;
  return condensed ? cssSpacing('tighter', '12px') : cssSpacing('looser-3', '48px');
});